import React from "react";
import { Modal, Button, Card } from "react-bootstrap";

export default function ConfirmDeleteModal({show, handleHide, organization, resident}){
  return (
    <Modal show={show} onHide={handleHide}>
      <Card className="mb-0">
        <Card.Header closeButton>
          <div>Delete {resident.first_name} {resident.last_name}</div>
        </Card.Header>
        <Card.Body>
          <p className="px-3 pt-3">
          Are you sure you want to delete this client? Deleting a client <b>CAN NOT BE UNDONE</b>. If you want to keep this client's information on file, please add a discharge date.
          </p>
          <p className="px-3 pb-3">
          If this client has any payments, invoices, documents, med logs, UA/BAs, or anything else associated with their name, <b>ALL OF THESE</b> will be deleted by clicking the delete button.
          </p>
          <div className="d-flex align-items-center pl-3 pr-3 pb-3 justify-content-end">
            <div className="btn btn-outline-secondary" onClick={handleHide}>
              No, keep this client
            </div>
            <Button 
              className='btn-danger ml-3' 
              href={`/organizations/${organization.name}/residents/${resident.id}`}
              data-method="delete">
              Yes, DELETE Forever.
            </Button>
          </div>
        </Card.Body>
      </Card>
    </Modal>
  );
}